import { render, staticRenderFns } from "./RadialGauge.vue?vue&type=template&id=064b405c&"
import script from "./RadialGauge.vue?vue&type=script&lang=js&"
export * from "./RadialGauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports